import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#050912] text-slate-100">
      <Navbar />
      <main className="flex-1 pt-36">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
